/* Map Controller
 *
 * @param cart_controller: An instance of CartCtrl
 *
 * @param ticket_controller: An instance of TicketCtrl (optional)
 */
app.controller('MapCtrl', function ($scope, $http, $modal, $timeout, $window, StorageService, TicketService, BucketService, cart_controller) {
    $scope.ticketack          = PosConfig;
    $scope.localized_or_default = localized_or_default;
    $scope.localized_title_or_original = localized_title_or_original;
    $scope.cart_controller    = cart_controller;

    $scope.map_size           = 'normal';
    $scope.map_width          = 948, // Keep in sync with style.css
    $scope.map_height         = 660; // Keep in sync with style.css

    $scope.map_classname      = '';
    $scope.seat_size          = 25;
    $scope.overview_seat_size = 18;

    var clamp = function (value, min, max) {
        return Math.max(min, Math.min(max, value));
    };

    var bounds_from_seats = function (seats) {
        if (!seats || !seats.length) {
            return null;
        }

        var bounds = {
            min_x: Infinity,
            max_x: -Infinity,
            min_y: Infinity,
            max_y: -Infinity
        };

        _.each(seats, function (s) {
            (s.position.x < bounds.min_x) && (bounds.min_x = s.position.x);
            (s.position.x > bounds.max_x) && (bounds.max_x = s.position.x);
            (s.position.y < bounds.min_y) && (bounds.min_y = s.position.y);
            (s.position.y > bounds.max_y) && (bounds.max_y = s.position.y);
        });

        return bounds;
    };

    // Height kept free under the stage/screen before the first seat row.
    // Keep a slim strip for zone labels placed above the top seats.
    var overview_screen_reserved = function () {
        return $scope.map_size === 'small' ? 72 : 28;
    };

    var seat_size_for_bounds = function (bounds, min_size, max_size, available_width, available_height, gap) {
        if (!bounds) {
            return max_size;
        }

        var columns = Math.max(1, bounds.max_x - bounds.min_x + 1);
        var rows = Math.max(1, bounds.max_y - bounds.min_y + 1);
        var size = Math.floor(Math.min(
            (available_width || $scope.map_width) / columns,
            (available_height || $scope.map_height) / rows
        )) - (typeof gap === 'number' ? gap : 2);

        return clamp(size, min_size, max_size);
    };

    var update_seat_sizes = function (zones) {
        var max_seat_size = $scope.map_size === 'small' ? 25 : 45;
        var seat_size = max_seat_size;
        var all_seats = [];

        _.each(zones, function (zone) {
            all_seats = all_seats.concat(zone.seats);
            seat_size = Math.min(
                seat_size,
                seat_size_for_bounds(bounds_from_seats(zone.seats), 16, max_seat_size)
            );
        });

        $scope.seat_size = seat_size;
        // Overview: tight pack (no per-seat gap), higher max to fill leftover height.
        $scope.overview_seat_size = seat_size_for_bounds(
            bounds_from_seats(all_seats),
            6,
            24,
            $scope.map_width,
            $scope.map_height - overview_screen_reserved(),
            /*gap*/ 0
        );
    };

    var zone_overview_tint = function (index) {
        // Stronger free-seat greens: alternate lightness and spread hue
        // widely so neighbouring zones stay distinct while icons remain.
        var hue = 95 + ((index * 31) % 70);
        var lightness = (index % 2 === 0) ? 34 : 48;
        var saturation = (index % 3 === 0) ? 58 : 42;
        return 'hsl(' + hue + ', ' + saturation + '%, ' + lightness + '%)';
    };

    $scope.overview_seat_style = function (seat, zone) {
        var style = {
            left: seat.position.overview_x + 'px',
            top: seat.position.overview_y + 'px',
            width: $scope.overview_seat_size + 'px',
            height: $scope.overview_seat_size + 'px'
        };

        if (seat.status === 'free' && !seat.forbidden && zone.overview && zone.overview.tint) {
            style['background-color'] = zone.overview.tint;
        }

        return style;
    };

    /**
     * Open the map modal
     *
     * @param string screening_id: The screening _id for which to show the map
     *
     * @param object ticket: Object as provided by Ticket::get_current_ticket()
     *
     * @param boolean show_cart_icon: True to show the cart icon link, false otherwise
     *
     * @param boolean multiple_select : True to allow the multiple selection, false otherwise
     *
     * @param object callbacks: An object of callback functions with the following keys:
     *  - on_add_to_cart: Function to call to add a seat to the cart
     *    This function receives the screening, the seat, the pricing key and a done function.
     *    The done function must be called with the new cart item and,
     *    (if any) an array of error messages.
     *  - on_remove_from_cart: Function to call to remove a seat from the cart
     *    This function receives the cart item index and a done function.
     *    The done function must be called with (if any) an array of error messages.
     *  - on_book_on_ticket: Function to call to book a seat on a ticket
     *    This function receives the screening, the seat and a done function.
     *    The done function must be called with the new booking and,
     *    (if any) an array of error messages.
     *  - on_unbook_on_ticket: Function to call to unbook a seat on a ticket
     *    This function receives the booking id and a done function.
     *    The done function must be called with (if any) an array of error messages.
     *  - on_close: Function to call when the modal is closed
     *    This function receives the number of items added to cart (can be negative) and
     *    the number of bookings made (can also be negative).
     *  - on_click_on_cart: Function to call when the cart icon is clicked
     *    This function receives the number of items added to cart (can be negative) and
     *    the number of bookings made (can also be negative).
     *
     * @param string initial_pricing_key: The pricing to be selected by default if provided
     *
     * @param boolean bypass_category_check_on_book : True to bypass the category check between selected
     *                                                pricing and seat categories, false otherwise
     *
     * @param boolean hide_map_modal : true to display map on modal, false otherwise
     *
     * @param boolean has_eligible_passes : true when the pass step should be shown
     */
    $scope.show_screening_map = function(screening_id, ticket, show_cart_icon, multiple_select, callbacks, initial_pricing_key, bypass_category_check_on_book, hide_map_modal, has_eligible_passes) {
        $scope.ticket                        = ticket;
        $scope.show_cart_icon                = show_cart_icon;
        $scope.multiple_select               = multiple_select;
        $scope.multiple_select_nb            = { "value": 0  };
        $scope.in_multiple_select_mode       = false;
        $scope.initial_pricing_key           = initial_pricing_key;
        $scope.bypass_category_check_on_book = !!bypass_category_check_on_book;
        $scope.hide_map_modal                = !!hide_map_modal;
        $scope.has_eligible_passes           = has_eligible_passes !== false;

        // Override map size if not in modal
        if (hide_map_modal) {
            $scope.map_width  = $window.innerWidth;
            $scope.map_height = $window.innerHeight;
        }

        // Register the callbacks
        if (callbacks) {
            [ 'on_close', 'on_click_on_cart',
              'on_add_to_cart', 'on_remove_from_cart',
              'on_confirm_bookings', 'on_release_booking',
              'on_book_on_ticket', 'on_unbook_on_ticket' ].forEach(function(event) {
                if (event in callbacks) {
                    $scope[event] = callbacks[event];
                }
            });
        }

        // Number of pricings to show above the map, before the "More" button
        $scope.pricings_per_row = $scope.multiple_select ? 4 : 5;

        // Context dependant pricings object
        // This is the selected zone pricings when a zone is selected,
        // the screening pricings on overview.
        $scope.pricings = {};

        $scope.nb_items_in_cart       = 0;
        $scope.nb_items_added_to_cart = 0;
        $scope.nb_bookings_made       = 0;

        $scope.tickets  = StorageService.get_tickets();
        $scope.ticket_bookability = {};
        $scope.bookings = [];
        $scope.step     = 'map';

        $scope.new_pass = { number: null, key: null };

        $scope.alerts              = [];
        $scope.zones               = null;
        $scope.nb_of_zones         = 0;
        $scope.selected_zone       = null;

        $scope.screening_id       = screening_id;
        $scope.screening_json_url = [
            PosConfig.engine_uri, PosConfig.api_path, 'screenings', $scope.screening_id
        ].join('/');
        $scope.nocache = ''; // first call can use the cache (which will be 2 min old at most but less if anybody booked a seat in the meantime);

        $scope.closeAlerts = function (delay) {
            $timeout(function() { $scope.alerts = []; }, delay);
        }

        if (!$scope.hide_map_modal) {
            var modalInstance = $modal.open({
                templateUrl: 'placeMapContent.html',
                scope: $scope
            });
        }

        $scope.setup_map = function () {
            if ($scope.nb_of_zones == 1) {
                $scope.show_zone($scope.zones[_.keys($scope.zones)[0]]);
            }
        };

        if (!$scope.hide_map_modal) {
            modalInstance.opened.then(function () {
                $scope.update_screening_data($scope.setup_map);
            });
            modalInstance.result.then(function (selectedItem) {}, function () {
                $scope.on_close && $scope.on_close(
                    $scope.nb_items_added_to_cart,
                    $scope.nb_bookings_made,
                    $scope.bookings,
                    // update screening data function, if needed
                    function () { $scope.update_screening_data(); }
                );
                // Reload the map
                $scope.update_screening_data($scope.setup_map);
            });

            $scope.close = function () {
                modalInstance.dismiss('cancel');
            };
        } else {
            $scope.update_screening_data($scope.setup_map);
        }
    };

    $scope.has_bookings = function () {
        return $scope.bookings.length > 0;
    }

    $scope.has_bookings_without_pricings_or_ticket = function () {
        return $scope.has_bookings && $scope.bookings.filter(function (b) {
            if (!b.pricing_id && !b.ticket_id) {
                return true;
            }
            if ($scope.booking_needs_external_voucher(b)) {
                var code = (b.external_voucher_code || '').toString().trim();
                return !code;
            }
            return false;
        }).length > 0;
    }

    $scope.booking_needs_external_voucher = function (booking) {
        if (!booking || !booking.pricing_id || !$scope.screening || !$scope.screening.pricings) {
            return false;
        }
        var pricing = $scope.screening.pricings[booking.pricing_id];
        return !!(pricing && pricing.rules && pricing.rules.external_voucher);
    }

    $scope.booking_external_voucher_provider = function (booking) {
        if (!$scope.booking_needs_external_voucher(booking)) {
            return null;
        }
        return $scope.screening.pricings[booking.pricing_id].rules.external_voucher;
    }

    $scope.external_voucher_code_label = function (provider) {
        if (provider === 'procinema') {
            return (PosConfig.i18n && PosConfig.i18n.external_voucher_code_procinema)
                || 'Code du bon ProCinéma';
        }
        return (PosConfig.i18n && PosConfig.i18n.external_voucher_code)
            || 'Code du bon';
    }

    $scope.go_to_map = function () {
        $scope.step = 'map';
    }

    $scope.go_to_pass = function () {
        $scope.step = 'pass';
    }

    $scope.go_to_next_booking_step = function () {
        if ($scope.has_eligible_passes) {
            return $scope.go_to_pass();
        }
        return $scope.go_to_pricings();
    }

    $scope.go_to_pricings = function () {
        $scope.update_ticket_bookability(function () {
            $scope.step = 'pricings';
            $scope.enrich_pricings_category_bookability();
        });
    }

    $scope.pricing_cascade_options = function () {
        return {
            buckets: $scope.screening && $scope.screening.buckets,
            bookings: $scope.bookings || [],
            roles: PosConfig.user_roles,
            sync_assign: function (buckets, tickettype, now, roles, category) {
                return BucketService.sync_assign(buckets, tickettype, now, roles, category);
            },
            reason: (PosConfig.i18n && PosConfig.i18n.no_seats_for_category)
                || 'Plus de places disponibles pour cette catégorie'
        };
    };

    /**
     * Gray out OTP pricings that have no matching category contingent capacity.
     */
    $scope.enrich_pricings_category_bookability = function () {
        if (!$scope.screening || !$scope.screening.pricings) {
            return;
        }
        globalThis.ticketack_enrich_pricings_category_bookability(
            $scope.screening.pricings,
            $scope.pricing_cascade_options()
        );
    };

    $scope.pricing_allows_seat = function (pricing, seat_category) {
        return globalThis.ticketack_pricing_allows_category(pricing, seat_category);
    };

    $scope.pricing_can_book_seat = function (pricing, seat_category) {
        if (!globalThis.ticketack_pricing_allows_category(pricing, seat_category)) {
            return false;
        }
        // Already holding a seat of this category: capacity was taken when the seat was reserved.
        if (_.some($scope.bookings, function (b) {
            return b.seat_category === seat_category;
        })) {
            return true;
        }
        if (pricing.cannot_book_reason) {
            return false;
        }
        return !!BucketService.sync_assign(
            $scope.screening.buckets, 'one-time-pass', Date.now(), PosConfig.user_roles, seat_category
        );
    };

    /**
     * Plain-text option label (no HTML inside <option> — browsers ignore nested tags/ng-if).
     */
    $scope.pricing_option_label = function (pricing, seat_category) {
        var name = $scope.localized_or_default(pricing.name);
        var price = pricing.price && pricing.price[PosConfig.currency];
        var label = name + ' (';
        if (pricing.variable_price) {
            var min = pricing.min_price && pricing.min_price[PosConfig.currency];
            var from = (PosConfig.i18n && PosConfig.i18n.from_price) || 'dès';
            label += min != null ? (from + ' ' + min + ' ') : '';
        }
        label += price + ' ' + PosConfig.currency + ')';
        if (!$scope.pricing_can_book_seat(pricing, seat_category)) {
            var reason = pricing.cannot_book_reason
                || (PosConfig.i18n && PosConfig.i18n.no_seats_for_category)
                || 'Plus de places disponibles pour cette catégorie';
            label += ' — ' + reason;
        }
        return label;
    };

    $scope.update_ticket_bookability = function (callback) {
        if (!$scope.tickets || !$scope.tickets.length) {
            $scope.ticket_bookability = {};
            callback && callback();
            return;
        }

        var ticket_ids = $scope.tickets.map(function (ticket) {
            return ticket._id;
        }).join(',');

        $http({
            method: 'GET',
            url: [
                PosConfig.engine_uri, PosConfig.api_path, 'screenings',
                $scope.screening_id, 'bookability'
            ].join('/') + '?tickets=' + encodeURIComponent(ticket_ids),
            headers: {
                'X-API-Key': PosConfig.api_key
            }
        }).success(function (rsp) {
            $scope.ticket_bookability = rsp.tickets || {};
            callback && callback();
        }).error(function () {
            callback && callback();
        });
    }

    $scope.go_to_results = function () {
        $scope.step = 'results';
    }

    $scope.show_overview = function () {
        $scope.selected_zone = null;
        $scope.pricings = $scope.screening.pricings;
    }
    $scope.show_zone = function (zone) {
        $scope.selected_zone = zone;
        $scope.pricings = $scope.selected_zone.pricings;
        if ($scope.ticket && $scope.ticket.ticket_data && $scope.ticket.ticket_data.activated_pricing) {
            if ($scope.pricings.length == 1 && $scope.pricings[0].key == $scope.ticket.ticket_data.activated_pricing.key)
                $scope.pricings = [];
        }
    };

    $scope.switch_multiple_select_mode = function () {
        $scope.in_multiple_select_mode = !$scope.in_multiple_select_mode;
        if (!$scope.in_multiple_select_mode)
            $scope.multiple_select_nb.value = 0;
    }
    $scope.closeAlert = function(index) { $scope.alerts.splice(index, 1); };

    /* Load the screening infos from the API */
    $scope.update_screening_data = function(callback) {
        var httpRequest = $http({
            method: 'GET',
            url: $scope.screening_json_url + $scope.nocache,
            headers: {
                'X-API-Key': PosConfig.api_key
            }
        }).success(function(rsp, status, headers) {
            globalThis.PosConfig.server_load = headers('x-load') || globalThis.PosConfig.server_load;
            // XXX: as Screening::__seats_retro_compat()
            var tickettypes = ['one-time-pass'];

            if ($scope.ticket) {
                tickettypes.push($scope.ticket.type._id);
            }

            var pledge_categories = globalThis.ticketack_otp_availability_pledge_categories(rsp.pricings);
            rsp.seats = {
                total:        BucketService.get_total_seats(rsp.buckets),
                available:    BucketService.get_available_seats_for_availability(
                    rsp.buckets, tickettypes, Date.now(), PosConfig.user_roles, pledge_categories
                ),
                unconfirmed:  BucketService.get_unconfirmed_seats(rsp.buckets),
                confirmed:    BucketService.get_confirmed_seats(rsp.buckets),
                used:         BucketService.get_used_seats(rsp.buckets),
            };

            $scope.screening = rsp;

            $scope.map_classname = rsp.cinema_hall.name.replace(/[\W_]+/g, '').toLowerCase();

            // determine if screening is still bookable
            $scope.screening.is_still_bookable = moment($scope.screening.stop_at).isAfter();

            // only show pricings allowed to current user
            var nb_allowed_pricings = 0;
            Object.keys($scope.screening.pricings).map(function (pricing, index) {
                var seller_roles = globalThis.ticketack_pricing_roles($scope.screening.pricings[pricing]);
                if (seller_roles !== null && _.intersection(seller_roles, PosConfig.user_roles).length === 0) {
                    delete $scope.screening.pricings[pricing];
                } else if (!globalThis.ticketack_pricing_can_be_sold_at_salepoint($scope.screening.pricings[pricing], PosConfig.salepoint)) {
                    delete $scope.screening.pricings[pricing];
                } else if (!globalThis.ticketack_pricing_is_available_at($scope.screening.pricings[pricing], Date.now())) {
                    delete $scope.screening.pricings[pricing];
                } else if (!globalThis.ticketack_pricing_has_stock($scope.screening.pricings[pricing])) {
                    delete $scope.screening.pricings[pricing];
                } else {
                    delete $scope.screening.pricings[pricing].sellers;
                    nb_allowed_pricings++;
                }
            })

            // Category exhaustion must be known before the cascade: an exhausted
            // tier stays visible and must not hide the next tier.
            $scope.enrich_pricings_category_bookability();
            globalThis.ticketack_apply_hides_pricings_while_available(
                $scope.screening.pricings,
                $scope.pricing_cascade_options()
            );
            nb_allowed_pricings = Object.keys($scope.screening.pricings).length;

            if ((nb_allowed_pricings <= 0 && !$scope.ticket) || !$scope.screening.is_still_bookable)
                $scope.screening.seats.available = 0;

            if ($scope.screening.seats.total>0 && $scope.screening.is_still_bookable)
                $scope.screening.seats.occupation_percentage = Math.round(100*($scope.screening.seats.confirmed + $scope.screening.seats.unconfirmed)/$scope.screening.seats.total, 1);

            $scope.nocache       = '?nocache=true'; // next calls (doing map changes) won't use cache
            /* Inject pricing key in pricing for easy access */
            for (key in $scope.screening.pricings) {
                $scope.screening.pricings[key].key = key;
            }

            // Order the pricings by priority
            $scope.screening.pricings = _.chain($scope.screening.pricings)
                .mapObject(function (p, key) { p.key = key; return p; })
                .sortBy(function (p) { return (p.opaque || {}).eshop_sort_weight ? p.opaque.eshop_sort_weight : Infinity; })
                .value();

            $scope.pricings = $scope.screening.pricings;

            $scope.zones = build_zones($scope.screening);
            build_overview($scope.zones);

            // Check for seats which are booked on the current ticket
            $scope.look_for_seats_on_ticket(/*no specific zone*/null, function (error, seats, ticket) {
                // Check for seats which are in the current user cart
                $scope.look_for_seats_in_cart(seats, function (error, seats, cart) {
                    // Check for seats which are being booked
                    $scope.look_for_seats_in_bookings(seats, function (error, seats, bookings) {
                        _.each($scope.zones, function (zone) {
                            _.each(zone.seats, function (seat) {
                                if (!seat.forbidden && seat.status !== 'booked') {
                                    seat.forbidden = (seat.status !== 'booking' && has_one_booked_seat_around(seat, $scope.zones));
                                }
                            });
                        });
                        // FIXME cart.items.length + $scope.bookings...
                        $scope.nb_items_in_cart = cart.items.length + $scope.bookings.length;
                        if ($scope.selected_zone) {
                            $scope.show_zone($scope.zones[$scope.selected_zone.name]);
                        }
                        callback && callback();
                    });
                });
            });

        }).error(function(rsp, status, headers, config) {
            callback && callback(rsp.flash && rsp.flash.error ? rsp.flash.error : null);
        });
    }

    $scope.look_for_seats_on_ticket =  function(seats, callback) {
        seats = seats || $scope.screening.cinema_hall.map.seats;
        if (!$scope.ticket) {
            return (callback && callback(null, seats));
        }
        TicketService.load_ticket_infos($scope.ticket._id, function (error, infos) {

            if (error) {
                $scope.alerts.push("An error occured while updating ticket");
                callback && callback(error);
            } else {
                $scope.ticket.ticket_data.contact  = infos.contact;
                $scope.ticket.ticket_data.bookings = infos.bookings;
                _.each($scope.ticket.ticket_data.bookings, function (booking) {
                    _.each(seats, function (s) {
                        if (booking.screening_id == $scope.screening._id &&
                            booking.seat == s.label) {
                            s.booking_id = booking._id;
                            s.status     = 'booked';
                        }
                    });
                });
                StorageService.store_ticket(ticket);
                $scope.tickets = StorageService.get_tickets();
                callback && callback(null, seats, $scope.ticket);
            }
        });
    };

    $scope.look_for_seats_in_cart = function(seats, callback) {
        seats = seats || $scope.screening.cinema_hall.map.seats;
        if (!$scope.cart_controller) {
            return (callback && callback(null, seats));
        }

        $scope.cart_controller.refresh(function (error, cart) {
            if (!error) {
                _.each(seats, function (s) {
                    var seat_in_cart = _.findWhere(
                        cart.items, {
                            "seat": s.label,
                            "item_id": $scope.screening._id
                        }
                    );
                    if (seat_in_cart)  {
                        s.index_in_cart = seat_in_cart.id;
                        s.status        = 'booking';
                    } else {
                        delete s.index_in_cart;
                    }
                });
            }
            callback && callback(null, seats, cart);
        });
    };

    $scope.look_for_seats_in_bookings = function (seats, callback) {
        seats = seats || $scope.screening.cinema_hall.map.seats;

        _.each(seats, function (s) {
            var bookings = Object.values($scope.bookings);
            var seat_in_bookings = _.findWhere(
                bookings, {
                    seat: s.label,
                    screening_id: $scope.screening._id
                }
            )
            if (seat_in_bookings) {
                s.booking_id = seat_in_bookings._id
                s.status = 'booking';
            }
        });

        callback && callback(null, seats, $scope.bookings);
    };

    $scope.add_new_pass = function() {
        $scope.new_pass.error = false;
        var advance_ticket_number = $scope.new_pass.advance_ticket_number;
        if (advance_ticket_number) {
            TicketService.get_ticket(null, null, function (err, ticket) {
                if (err || !ticket) {
                    $scope.new_pass.error = true;
                } else {
                    StorageService.store_ticket(ticket);
                    $scope.tickets = StorageService.get_tickets();

                    $scope.new_pass.advance_ticket_number = null;
                }
            }, advance_ticket_number);
            return;
        }

        if (!$scope.new_pass.number || !$scope.new_pass.key) {
            $scope.new_pass.error = true;
            return;
        }

        TicketService.get_ticket($scope.new_pass.number, $scope.new_pass.key, function (err, ticket) {
            if (err || !ticket) {
                $scope.new_pass.error = true;
            } else {
                StorageService.store_ticket(ticket);
                $scope.tickets = StorageService.get_tickets();
                if ($scope.step === 'pricings') {
                    $scope.update_ticket_bookability();
                }

                $scope.new_pass.number = null;
                $scope.new_pass.key    = null;
            }
        });
    }

    $scope.remove_ticket = function(ticket) {
        StorageService.remove_ticket(ticket);
        $scope.tickets = StorageService.get_tickets();
        if ($scope.step === 'pricings') {
            $scope.update_ticket_bookability();
        }
    },

    $scope.validate_cart = function() {
        window.top.postMessage({
            action: 'tkt::go_to_cart'
        }, '*');
    };

    var has_one_booked_seat_around = function (current_seat, zones) {
        return false; // COVID rules disabled
        var left   = {x: current_seat.position.x - 1, y: current_seat.position.y};
        var right  = {x: current_seat.position.x + 1, y: current_seat.position.y};

        var has_one_booked_seat_around = false;

        _.each(zones, function (zone) {
            _.each(zone.seats, function (seat) {
                if (seat.position.x === left.x && seat.position.y === left.y && (seat.status === 'booked' || (seat.status == 'booking' && !seat.index_in_cart && !seat.booking_id))) {
                    has_one_booked_seat_around = true;
                } else if (seat.position.x === right.x && seat.position.y === right.y && (seat.status === 'booked' || (seat.status == 'booking' && !seat.index_in_cart  && !seat.booking_id))) {
                    has_one_booked_seat_around = true;
                }
            });
        });

        return has_one_booked_seat_around;
    };

    /* Build an object with a key for each zone.
     *
     * Each zone contains the seats with translated
     * coordinates (to be centered) and an array of pricings,
     * since usable pricings should be different for each zone..
     */
    var build_zones = function (screening) {
            if ($window.innerWidth < 900) {
                $scope.map_size = 'small';
                $scope.seat_size = 20;
            }
        // Organize map seats by zone
        var zones = {};
        $scope.nb_of_zones = 0;
        _.each(screening.cinema_hall.map.seats, function (s) {
            var zone_name = s.placing.zone;
            if (!zones[zone_name]) {
                zones[zone_name] = {
                    name: zone_name,
                    seats: []
                };
                $scope.nb_of_zones ++;
            }
            zones[zone_name].seats.push(s);
        });

        update_seat_sizes(zones);

        // Usable area is the map area minus one seat since the
        // seats coordinates are computed for their top left corner
        var usable_width  = $scope.map_width - $scope.seat_size;
        var usable_height = $scope.map_height - $scope.seat_size;

        _.each(zones, function (zone, zone_name) {
            // Bounds of this zone
            var min_x = Infinity,
                max_x = 0,
                min_y = Infinity,
                max_y = 0;

            // Compute the zone external bounds
            _.each(zone.seats, function (s) {
                s.position.single_view_x = s.position.x * ($scope.seat_size + 2);
                s.position.single_view_y = s.position.y * ($scope.seat_size + 2);
                (s.position.single_view_x < min_x) && (min_x = s.position.single_view_x);
                (s.position.single_view_x > max_x) && (max_x = s.position.single_view_x);
                (s.position.single_view_y < min_y) && (min_y = s.position.single_view_y);
                (s.position.single_view_y > max_y) && (max_y = s.position.single_view_y);
            });

            // Compute the translation
            //var translation_x = Math.max(0, ((usable_width - (max_x - min_x)) / 2) - min_x),
            var translation_x = ((usable_width - (max_x - min_x)) / 2) - min_x,
               translation_y = ((usable_height - (max_y - min_y)) / 2) - min_y;
               //translation_y = 50;

            // Apply the translation
            _.each(zone.seats, function (s) {
                s.position.single_view_x += translation_x;
                s.position.single_view_y += translation_y;
            });

            // Original bounds of the zone
            zone.bounds = {
                max_x: max_x,
                min_x: min_x,
                max_y: max_y,
                min_y: min_y
            };
            zone.center = {
                x: max_x - ((max_x - min_x) / 2),
                y: max_y - ((max_y - min_y) / 2)
            };

            // Translate bounds in single view
            max_x += translation_x;
            min_x += translation_x;
            max_y += translation_y;
            min_y += translation_y;
            zone.single_view = {
                bounds: {
                    max_x: max_x,
                    min_x: min_x,
                    max_y: max_y,
                    min_y: min_y
                }
            };

            // Compute the rows
            zone.single_view.rows = {};
            _.each(zone.seats, function (s) {
                zone.single_view.rows[s.placing.row] = {
                    label: s.placing.row,
                    x: zone.single_view.bounds.min_x - $scope.seat_size,
                    y: s.position.single_view_y
                };
            });

            //Sort seats by y and x
            zone.seats.sort(function (a, b) {
                if (a.position.y != b.position.y)
                    return a.position.y > b.position.y ? 1 : -1;
                if (a.position.x != b.position.x)
                    return a.position.x > b.position.x ? 1 : -1;

                return 0;
            });
        });

        // Set each zone pricings
        _.each(zones, function (zone, zone_name) {
            var zone_seats_categories = _.chain(_.pluck(zone.seats, 'category'))
                .uniq()
                .value();

            zone.pricings = _.filter(screening.pricings, function (p) {
                return _.some(zone_seats_categories, function (cat) {
                    return globalThis.ticketack_pricing_allows_category(p, cat);
                });
            });

            if ($scope.ticket && $scope.ticket.ticket_data && $scope.ticket.ticket_data.activated_pricing)
                zone.pricings.push($scope.ticket.ticket_data.activated_pricing);
        });

        var ticket_pricing_category = null;
        if ($scope.ticket && $scope.ticket.ticket_data && $scope.ticket.ticket_data.activated_pricing)
            ticket_pricing_category = globalThis.ticketack_pricing_seatless_pledge_category(
                $scope.ticket.ticket_data.activated_pricing
            );

        // Flag forbidden seats: no sellable pricing for this seat category,
        // or no matching OTP contingent capacity for that category.
        _.each(zones, function (zone) {
            _.each(zone.seats, function (seat) {
                var can_book = _.some(zone.pricings, function (p) {
                    if (p.cannot_book_reason) {
                        return false;
                    }
                    if (!globalThis.ticketack_pricing_allows_category(p, seat.category)) {
                        return false;
                    }
                    return !!BucketService.sync_assign(
                        screening.buckets,
                        'one-time-pass',
                        Date.now(),
                        PosConfig.user_roles,
                        seat.category
                    );
                });
                if (ticket_pricing_category != null && ticket_pricing_category === seat.category) {
                    can_book = true;
                }
                if (!can_book) {
                    seat.forbidden = seat.status === 'free' ? true : false;
                }
            });
        });

        return zones;
    };

    /* Add overview properties to zones
     */
    var build_overview = function (zones) {

        // Usable area is the map area minus one seat since the
        // seats coordinates are computed for their top left corner
        var usable_width  = $scope.map_width - $scope.overview_seat_size;
        var usable_height = $scope.map_height - $scope.overview_seat_size;

        // Bounds of all the seats, needed for the overview
        var overview_min_x = Infinity,
            overview_max_x = 0,
            overview_min_y = Infinity,
            overview_max_y = 0;
        _.each(zones, function (zone, zone_name) {
            _.each(zone.seats, function (s) {
                // Compute the zone bounds in the overview
                (s.position.x < overview_min_x) && (overview_min_x = s.position.x);
                (s.position.x > overview_max_x) && (overview_max_x = s.position.x);
                (s.position.y < overview_min_y) && (overview_min_y = s.position.y);
                (s.position.y > overview_max_y) && (overview_max_y = s.position.y);
            });
        });

        overview_max_x *= ($scope.overview_seat_size + /*no space between seats*/0);
        overview_max_y *= ($scope.overview_seat_size + /*no space between seats*/0);

        // Compute the overview translation.
        // X: center the seat block. Y: flush under the screen, cancel empty
        // grid rows above the first real seat (avoids the large stage gap).
        var overview_translation_x = ((usable_width - (overview_max_x - overview_min_x)) / 2) - overview_min_x,
            overview_translation_y = overview_screen_reserved()
                - (overview_min_y * $scope.overview_seat_size);

        // Apply the overview translation
        var zone_index = 0;
        _.each(zones, function (zone, zone_name) {
            var min_ox = Infinity,
                max_ox = -Infinity,
                min_oy = Infinity,
                max_oy = -Infinity;

            _.each(zone.seats, function (s) {
                s.position.overview_x = (s.position.x * $scope.overview_seat_size) + overview_translation_x;
                s.position.overview_y = (s.position.y * $scope.overview_seat_size) + overview_translation_y;
                (s.position.overview_x < min_ox) && (min_ox = s.position.overview_x);
                (s.position.overview_x > max_ox) && (max_ox = s.position.overview_x);
                (s.position.overview_y < min_oy) && (min_oy = s.position.overview_y);
                (s.position.overview_y > max_oy) && (max_oy = s.position.overview_y);
            });

            zone.overview = {
                tint: zone_overview_tint(zone_index++),
                bounds: {
                    max_x: max_ox,
                    min_x: min_ox,
                    max_y: max_oy,
                    min_y: min_oy
                },
                center: {
                    x: min_ox + ((max_ox - min_ox + $scope.overview_seat_size) / 2),
                    y: min_oy + ((max_oy - min_oy + $scope.overview_seat_size) / 2)
                }
            };
        });

        return zones;
    };

    $scope.clicked_on_seat = function(seat) {
        // Disable click on already processing seat
        if (seat.is_processing) {
            return false;
        }

        // While covid-19. Check for role, this allow on-site users to
        // be able to book for a seat even if the seat next it is already booked
        if (seat.forbidden === true && $scope.ticketack.user_roles.indexOf('on-site') === -1) {
            return false;
        }

        switch (seat.status) {
            case 'free':
                if ($scope.bookings.length >= $scope.ticketack.max_tickets_per_screening) {
                    $scope.alerts.push({msg: $scope.ticketack.i18n.max_ticket_per_screening_reached, type: "danger"});
                    $scope.closeAlerts(3000);
                    return false;
                } else if ($scope.nb_items_in_cart >= $scope.ticketack.max_tickets_in_cart) {
                    $scope.alerts.push({msg: $scope.ticketack.i18n.max_items_in_cart_reached, type: "danger"});
                    $scope.closeAlerts(3000);
                    return false;
                }
                return $scope.add_to_cart([seat]);
            case 'booking':
                if (seat.booking_id) {
                    var booking = $scope.bookings.find(function (b) {
                        return b._id === seat.booking_id;
                    });
                    if (booking) {
                        $scope.release_booking(booking, seat)
                    }
                }
                /*if (seat.index_in_cart) {
                    return $scope.remove_from_cart(seat, seat.index_in_cart);
                }*/
                break;
            case 'booked':
                // The seat has been booked on the current ticket
                if ($scope.ticket && seat.booking_id) {
                    return $scope.unbook_on_ticket(seat, seat.booking_id);
                }
                return false;
        }
    };

    $scope.clicked_on_cart = function() {
        $scope.on_click_on_cart && $scope.on_click_on_cart(
            $scope.nb_items_added_to_cart,
            $scope.nb_bookings_made
        );
    };

    $scope.add_to_cart = function(seats, callback) {
        if ($scope.on_add_to_cart) {
            _.each(seats, function (s) { s.is_processing = true; });
            $scope.on_add_to_cart($scope.screening, seats, null, function(error, bookings) {
                if (error) {
                    error.forEach(function (msg) {
                        $scope.alerts.push({msg: msg, type: "danger"});
                    });
                    $scope.closeAlerts(3000);
                    callback && callback(error);
                } else {
                    // Mark booked seats as being booked
                    _.each(bookings, function (booking) {
                        if ((seat = _.findWhere(seats, { "label": booking.seat }))) {
                            seat.status     = "booking";
                            seat.booking_id = booking._id;
                            booking.seat_category = seat.category;
                            $scope.bookings.push(booking);
                        }
                    });
                    callback && callback(null, bookings);
                }
                _.each(seats, function (s) { s.is_processing = false; });

                // Reload the map
                $scope.update_screening_data($scope.setup_map);
            });
        }
    };

    $scope.remove_from_cart = function(seat, index) {
        if ($scope.on_remove_from_cart) {
            seat.is_processing = true;
            $scope.on_remove_from_cart(index, function(error) {
                if (error) {
                    error.forEach(function (msg) {
                        $scope.alerts.push({msg: msg, type: "danger"});
                    });
                } else {
                    // Release seat
                    seat.status = "free";
                    delete seat.index_in_cart;
                    // Remember this action
                    $scope.nb_items_added_to_cart --;
                    // Update cart items counter
                    $scope.nb_items_in_cart --;
                }
                seat.is_processing = false;

                // Reload the map
                $scope.update_screening_data($scope.setup_map);
            });
        }
    };

    $scope.release_booking = function(booking, seat) {
        if ($scope.on_release_booking) {
            $scope.on_release_booking(booking, function (error, removed) {
                if (error) {
                    error.forEach(function (msg) {
                        $scope.alerts.push({msg: msg, type: "danger"});
                    });
                } else {
                    if (seat) {
                          seat.status = "free";
                        delete seat.booking_id;
                    }
                    $scope.bookings = $scope.bookings.filter(function (b) {
                        return b._id !== booking._id;
                    });
                }
                // We could force reload the map here, but that's not needed as we'll do it once we close the modal
                // $scope.update_screening_data($scope.setup_map);
            });
        }
    }

    $scope.confirm_bookings = function(callback) {
        if ($scope.on_confirm_bookings) {
            $scope.on_confirm_bookings($scope.bookings, function(error, rsp) {
                if (error) {
                    error.forEach(function (msg) {
                        $scope.alerts.push({msg: msg, type: "danger"});
                    });
                    $scope.closeAlerts(3000);
                    callback && callback(error);
                } else {
                    rsp.map(function (result) {
                        if (('added' in result) && result.added)
                            $scope.nb_items_added_to_cart ++;
                        else if (('confirmed' in result) && result.confirmed)
                            $scope.nb_bookings_made ++;
                    });
                    $scope.bookings = [];
                    $scope.results  = rsp;
                    $scope.go_to_results();
                    callback && callback(null, rsp);
                }
            });
        }
    };

    $scope.book_on_ticket = function (seat) {
        if ($scope.on_book_on_ticket) {
            seat.is_processing = true;
            $scope.on_book_on_ticket($scope.screening, seat, function(error, booking) {
                if (error) {
                    error.forEach(function (msg) {
                        $scope.alerts.push({msg: msg, type: "danger"});
                    });
                } else if (booking) {
                    $scope.bookings = $scope.bookings.filter(function (b) {
                        return b._id !== booking._id;
                    });

                    // Mark this seat as booked
                    seat.status        = "booked";
                    seat.booking_id    = booking._id;
                    // Remember this action
                    $scope.nb_bookings_made ++;
                }
                seat.is_processing = false;

                // Reload the map
                $scope.update_screening_data($scope.setup_map);
            });
        }
    };

    $scope.unbook_on_ticket = function (seat, booking_id) {
        if ($scope.on_unbook_on_ticket) {
            seat.is_processing = true;
            $scope.on_unbook_on_ticket(booking_id, function(error) {
                if (error) {
                    error.forEach(function (msg) {
                        $scope.alerts.push({msg: msg, type: "danger"});
                    });
                } else {
                    // Release seat
                    seat.status = "free";
                    delete seat.booking_id;
                    // Remember this action
                    $scope.nb_bookings_made --;
                }
                seat.is_processing = false;

                // Reload the map
                $scope.update_screening_data($scope.setup_map);
            });
        }
    };

    $scope.do_multiple_selection = function(seat) {
        if (!$scope.in_multiple_select_mode) {
            return false;
        }

        if ($scope.multiple_select_nb.value <= 0) {
            return true;
        }

        var matching_seats = $scope.find_multiple_matching_seats(seat, $scope.multiple_select_nb.value);
        return $scope.add_to_cart(matching_seats, function (error, cart_items) {
            if (cart_items) {
                if (cart_items.length === $scope.multiple_select_nb.value){
                    $scope.switch_multiple_select_mode();
                } else {
                    $scope.multiple_select_nb.value -= cart_items.length;
                }
            }
        });
    };

    $scope.find_multiple_matching_seats = function (top_left_seat, nb) {
        var match = [];

        _.each($scope.selected_zone.seats, function (s) {
            if (s.position.x >= top_left_seat.position.x &&
                s.position.y >= top_left_seat.position.y &&
                s.status == 'free' &&
                !s.forbidden) {

                if (match.length < $scope.multiple_select_nb.value) {
                    match.push(s);
                }
            }
        });

        return match;
    };

    $scope.close = function () {
        window.top.postMessage({"action": "tkt::map:close"}, '*')
    }

    $scope.is_ticket_bookable = function (ticket) {
        var info = $scope.ticket_bookability[ticket._id];
        if (info && typeof info.can_book === 'boolean') {
            return info.can_book;
        }

        return $scope.ticket_can_book(ticket);
    }

    $scope.ticket_option_label = function (ticket) {
        var label = (ticket.name.length > 35 ? ticket.shortname : ticket.name)
            + ' (' + ticket.ticket_data.vdr_auth_serial + '…)';
        var info = $scope.ticket_bookability[ticket._id];

        if (info && !info.can_book && info.cannot_book_explanation) {
            label += ' — ' + info.cannot_book_explanation;
        }

        return label;
    }

    $scope.ticket_can_book = function (ticket) {
        // first check screening rules
        const matching_bucket = BucketService.assign(
            $scope.screening.buckets,
                ticket.type._id,
            Date.now(),
                PosConfig.user_roles
        );

        if (!matching_bucket)
            return false;

        // if screening rules pass, check ticket windows
        return TicketService.windows_match({
            windows: ticket.ticket_data.windows,
            bookings: ticket.ticket_data.bookings
        }, $scope.screening);
    }

   /*
    * Refresh the (cached) map every 30 seconds or 60 seconds to have current
    * state of bookings (if server load permits).
    */
    var auto_refresh_map = function() {
        if (PosConfig.server_load == 'very-low' || PosConfig.server_load == 'low') {
            $scope.nocache = '';
            if ($scope.step === 'map')
                $scope.update_screening_data($scope.setup_map);
            var frequency = (PosConfig.server_load == 'very-low') ? 30000 : 60000;
            setTimeout(auto_refresh_map, frequency);
        } else {
            var frequency = 300000;
            console.log('server load is ' + PosConfig.server_load + ', skipping map auto-update for ' + (frequency/1000) + ' seconds');
            setTimeout(auto_refresh_map, frequency);
        }
    }
    setTimeout(auto_refresh_map, 30000);

    // Expose public methods
    this.show_screening_map = function(screening_id, ticket, show_cart_icon, multiple_select, callbacks, initial_pricing_key, bypass_category_check_on_book, hide_map_modal, has_eligible_passes) {
        return $scope.show_screening_map(screening_id, ticket, show_cart_icon, multiple_select, callbacks, initial_pricing_key, bypass_category_check_on_book, hide_map_modal, has_eligible_passes);
    }

    return this;
});
